import axios from 'axios';

const BASE_URL = '/app/userSetting/automation';

export const saveAutomationUserSettings = async (autoOpenConfigScreen) => {
    const { data } = await axios.post(BASE_URL, { autoOpenConfigScreen });

    return data;
};

export const getAutomationUserSettings = async() => {
    const { data } = await axios.get(BASE_URL);

    return data;
};
